import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_EARNED_CAB} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {EarnedCabReportContent} from './EarnedCabReportContent';
import reportPayload from './reportPayload';

export const EarnedCabReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'Earned Client Acquisition Bonus')}
      description={tt(
        'description',
        'These Coaches earned their CAB in their first 30 days. Time to celebrate & help them to their next milestone!',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={EarnedCabReportContent}
    />
  );
};

export default withHOC(
  withTranslation('report.EarnedCabReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_EARNED_CAB,
    popoverContentProps: {},
  }),
)(EarnedCabReport);
